import memoizeOne from 'react-utils/memoizeOne';
export const getPortalId = memoizeOne(() => {
  const portalIdArray = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/.exec(document.location.pathname);
  const currentWindow = window;
  const portalId = portalIdArray && portalIdArray.length > 1 ? Number(portalIdArray[1]) : currentWindow.hubspot !== undefined && currentWindow.hubspot.portal !== undefined ? currentWindow.hubspot.portal.id : undefined;
  return portalId;
});
export const clearPortalIdCache = () => {
  getPortalId.resetCache();
};